import Cookie from 'js-cookie';

export default {
  methods: {
    hasCookie(cookie) {
      return (Cookie.get(cookie) === 'true') ? true : false;
    },
    removeCookie(cookie){
      Cookie.remove(cookie);
    },
    setCookie(cookie, value) {
      Cookie.set(cookie, value);
    }
  }
}
